import React from "react";
import { useSelector } from 'react-redux';
import "./About.css";
import one from "../../assest/companyone.png";
import Arrow from "../../assest/arrow.png";

const certifications = [
  {
    title: "Food Safety Certification",
    issuedBy: "Singapore Food Agency",
    issueDate: "Jan 2024",
    licenseNo: "SFA-009234-A",
    imageUrl: one,
  },
  {
    title: "ISO 9001 Certified",
    issuedBy: "International Standards Org",
    issueDate: "Mar 2024",
    licenseNo: "ISO-78452-B",
    imageUrl: one,
  },
  {
    title: "Environmental Compliance",
    issuedBy: "Green Standards Board",
    issueDate: "Feb 2024",
    licenseNo: "GSB-56231-C",
    imageUrl: one,
  },
];

const Certifications = () => {
  const { language } = useSelector((state) => state.language);

  const translations = {
    gb: {
      sectionTitle: "Company's Certifications / Licenses",
      viewCertificateButton: "View Certificate",
      issuedByLabel: "Issued by:",
      issueDateLabel: "Issue Date:",
      licenseNoLabel: "License No:",
    },
    sa: {
      sectionTitle: "شهادات وتراخيص الشركة",
      viewCertificateButton: "عرض الشهادة",
      issuedByLabel: "منحت من قبل:",
      issueDateLabel: "تاريخ الإصدار:",
      licenseNoLabel: "رقم الترخيص:",
    },
    fr: {
      sectionTitle: "Certifications et Licences de l'Entreprise",
      viewCertificateButton: "Voir le Certificat",
      issuedByLabel: "Délivré par :",
      issueDateLabel: "Date de délivrance :",
      licenseNoLabel: "Numéro de licence :",
    },
    de: {
      sectionTitle: "Zertifikate und Lizenzen des Unternehmens",
      viewCertificateButton: "Zertifikat ansehen",
      issuedByLabel: "Ausgestellt von:",
      issueDateLabel: "Ausstellungsdatum:",
      licenseNoLabel: "Lizenznummer:",
    },
  };

  const t = translations[language] || translations.gb;

  return (
    <section className="certifications-section py-5">
      <div className="container">
        {/* Centered Heading */}
        <div className="text-center mb-5">
          <h2 className="section-title position-relative d-inline-block">
            {t.sectionTitle}
            <div className="underline mx-auto bg-danger"></div>
          </h2>
        </div>

        <div className="row g-4">
          {certifications.map((cert, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
              <div className="cert-card shadow-sm rounded-4 p-4 h-100 hover-effect">
                <img
                  className="cert-logo img-fluid d-block mx-auto mb-4"
                  src={cert.imageUrl}
                  alt="Certification Logo"
                  style={{ maxHeight: "80px" }}
                />
                
                <h3 className="cert-title text-center fw-bold mb-4">{cert.title}</h3>
                
                <div className="cert-details">
                  <p className="cert-detail">
                    {t.issuedByLabel} <strong>{cert.issuedBy}</strong>
                  </p>
                  <p className="cert-detail">{t.issueDateLabel} {cert.issueDate}</p>
                  <p className="cert-detail">{t.licenseNoLabel} {cert.licenseNo}</p>
                </div>

                <div className="text-center mt-4 pt-3">
                  <button className="btn btn-outline-danger rounded-pill px-4 py-2 d-flex align-items-center mx-auto hover-effect-btn">
                    {t.viewCertificateButton}
                    <img
                      src={Arrow}
                      alt="Arrow Icon"
                      className="ms-2 arrow-icon"
                      style={{
                        width: "26px",
                        height: "26px",
                        transition: "transform 0.3s ease",
                      }}
                    />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .cert-card {
          transition: all 0.3s ease;
          border: 1px solid rgba(0,0,0,0.1);
        }
        .hover-effect:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(220, 53, 69, 0.1) !important;
          border-color: rgba(220, 53, 69, 0.2);
        }
        .cert-title {
          color: #333;
          transition: color 0.3s ease;
        }
        .hover-effect:hover .cert-title {
          color: #dc3545;
        }
        .hover-effect-btn:hover {
          background-color: #dc3545 !important;
          color: white !important;
        }
        .hover-effect-btn:hover .arrow-icon {
          filter: brightness(0) invert(1);
          transform: translateX(5px);
        }
        .underline {
          height: 3px;
          width: 80px;
          margin-top: 15px;
        }
        .section-title {
          color: #333;
        }
      `}</style>
    </section>
  );
};

export default Certifications;